import { api } from '@/services/api'
export default {
  methods: {
    swapRank (Value) {
      let row = Value.row
      let direction = Value.arrow === 'up'
      let index = this.data.indexOf(row)
      this.isLoading = true;
      (async () => {
        let swapRow = null
        if (direction) {
          if (!row.ranked_.isFirst && row.status_.isFirst) {
            swapRow = await this.requestsSwapGetRowData((this.model.pagination.current.currentPage - 1) * this.model.pagination.size - 1)
          } else {
            swapRow = this.data[index - 1]
          }
        } else {
          if (!row.ranked_.isLast && row.status_.isLast) {
            swapRow = await this.requestsSwapGetRowData(this.model.pagination.current.currentPage * this.model.pagination.size)
          } else {
            swapRow = this.data[index + 1]
          }
        }
        if (!swapRow) {
          this.isLoading = false
          this.requestErrorHandler('Failed swap rank')
        }
        await this.requestsSwapPatchData(row, swapRow)
      })()
        .then(_ => {
          this.requestGetData()
        })
        .catch(e => {
          // eslint-disable-next-line
          console.error(e)
          this.isLoading = false
          this.requestErrorHandler(e, 'Failed swap rank')
        })
    },
    requestsSwapGetRowData (Skip) {
      return new Promise(resolve => {
        let requestProps = this.createGetRequest()
        requestProps.params['select'] = `${this.model.store.mainField},rank`
        requestProps.params['take'] = 1
        requestProps.params['skip'] = Skip
        return api
          .get(requestProps.url, {
            requestId: `requestGetSwapData-${this._uid}`,
            params: requestProps.params
          })
          .then(response => {
            if (response.data.value[0]) {
              resolve(response.data.value[0])
            } else {
              throw Error('Error get swap item')
            }
          })
      })
    },
    requestsSwapPatchData (Left, Right) {
      let mainField = this.model.store.mainField
      return Promise.all([
        this.requestSwapPatchData({ [mainField]: Left[mainField], rank: Right.rank }),
        this.requestSwapPatchData({ [mainField]: Right[mainField], rank: Left.rank })
      ])
    },
    requestSwapPatchData (Data) {
      // this.model.store.mainField
      return api({
        method: this.model.store.patch.method,
        url: this.checkJsTemplate(this.model.store.patch.url, Data),
        data: Data
      })
        .then(response => {
          this.$bus.$emit('Patch-Grid', { id: this.model.id, data: Data, response: response })
        })
        .catch(e => {
          this.isLoading = false
          this.requestErrorHandler(e, this.L10n('error-update-item'))
        })
    }
  }
}
